/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Level_SuspensionInputs */



/**
* | output |
* | --- |
* | "Suspension" |
*
* @param {Sanction_Level_SuspensionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_level_suspension = /** @type {((inputs?: Sanction_Level_SuspensionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Level_SuspensionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Suspension")
	if (locale === "es") return /** @type {LocalizedString} */ ("Suspensión")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Suspensão")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sospensione")
	return /** @type {LocalizedString} */ ("Suspension")
});